<template>
    <main class="main" id="main">

        <!---------------Blog-------------------->

        <div class="top_line">
            <div class="container">
                <h1>Блог</h1>
            </div>
        </div>

        <section class="section s-blog">
            <div class="container">
                <div class="blog">

                    <div class="blog_card_links">

                        <div class="prev_article">

                            <router-link tag="button" type="button" class="prev" v-if="last" :to="'/blog/' + last">
                                <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/blog/arrow-p.svg" alt="">
                                <span>предыдущая статья</span>
                            </router-link>

                        </div>

                        <div class="back_world_food" v-if="blog.tags !== 'all' && tags[blog.tags]">
                            <router-link to="/blog">назад в <strong>{{tags[blog.tags]}}</strong></router-link>
                        </div>
                        <div class="back_world_food" v-else>
                            <router-link to="/blog">назад в <strong>список статей</strong></router-link>
                        </div>

                        <div class="next_article">
                            <router-link tag="button" type="button" class="next" v-if="next" :to="'/blog/' + next">
                                <span>следующая статья</span>
                                <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/blog/arrow-n.svg" alt="">
                            </router-link>
                        </div>

                    </div>

                    <!--------- main part of card ----------->

                    <div class="blog_body">

                        <div class="blog_card">

                            <div class="card_side">

                                <div class="card_title">
                                    <h1>{{blog.title}}</h1>
                                    <span>{{blog.created_at}}</span>
                                </div>

                                <div class="card_middle">
                                    <img :src="blog.image" v-if="blog.image !== 'https://img.when-hungry.com/'" alt="">
                                </div>

                                <div class="card_bottom" v-html="blog.full_text">
                                </div>

                                <div class="comments_part">

                                    <div class="comment" v-for="reply in replies" :key="reply.id">
                                        <span class="name">{{reply.name}}</span>
                                        <span class="time">{{reply.created_at}}</span>
                                        <p>{{reply.text}}</p>
                                    </div>
                                </div>

                                <div class="comment_application" v-if="auth.user">
                                    <input type="text" name="" placeholder="Имя" required>
                                    <textarea name="" cols="30" rows="10" placeholder="Комментарий"></textarea>
                                    <button type="submit" class="comment_btn"><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/blog/comment.svg" alt=""></button>
                                </div>

                                <!--div class="share_socials">
                                    <a href="#">Поделиться с друзьям</a>
                                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/blog/vk.svg" alt="">
                                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/blog/fb.svg" alt="">
                                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/blog/odkl.svg" alt="">
                                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/blog/whapp.svg" alt="">
                                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/blog/tlg.svg" alt="">
                                </div-->
                            </div>
                        </div>

                      <div class="blog_right">
                        <div class="blog_extra_info">
                          <div id="vk_groups"></div>
                          <div class="links">
                            <ul>
                              <li><router-link to="/present">В магазин</router-link></li>
                              <li><router-link to="/affiliate">Заработать на еду</router-link></li>
                              <li><router-link to="/contacts">Прислать свой рецепт или статью</router-link></li>
                              <li><router-link to="/investment">Партнерская программа</router-link></li>
                            </ul>
                          </div>

                        </div>
                        <div class="links">
                          <ul>
                            <li><router-link to="/present">В магазин</router-link></li>
                            <li><router-link to="/affiliate">Заработать на еду</router-link></li>
                            <li><router-link to="/contacts">Прислать свой рецепт или статью</router-link></li>
                            <li><router-link to="/investment">Партнерская программа</router-link></li>
                          </ul>
                        </div>
                      </div>
                      <div class="links">
                        <ul>
                          <li><router-link to="/present">В магазин</router-link></li>
                          <li><router-link to="/affiliate">Заработать на еду</router-link></li>
                          <li><router-link to="/contacts">Прислать свой рецепт или статью</router-link></li>
                          <li><router-link to="/investment">Партнерская программа</router-link></li>
                        </ul>
                      </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import axios from '@/router/http'
export default {
  name: 'singleBlog',
  props: ['city', 'mapinit', 'geo', 'auth'],
  data () {
    return {
      tags: {
        all: 'показать все',
        news: 'новости',
        interesting: 'интересное',
        hyip: 'хайп',
        interview: 'интервью',
        media: 'мы в сми',
        collections: 'подборки',
        food: 'мировая еда',
        culinary_blog: 'кулинарный блог',
        memes: 'мемы'
      },
      activeTag: 'all',
      blog: {},
      replies: [],
      last: null,
      next: null
    }
  },
  created () {
    if (this.auth.uid) this.initAjax()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initAjax()
        }
      }, 100)
    }
  },
  mounted () {
    $('.blog_nav').slick({
      infinite: true,
      dots: false,
      arrows: true,
      slidesToShow: 7,
      slidesToScroll: 1,
      swipeToSlide: true,
      waitForAnimate: true,
      speed: 200,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 6,
            variableWidth: true
          }
        },
        {
          breakpoint: 986,
          settings: {
            slidesToShow: 5,
            variableWidth: true,
            arrows: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 5,
            variableWidth: true,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 3,
            variableWidth: true,
            dots: true,
            arrows: false
          }
        }
      ]
    })
    if (typeof VK === 'object') {
      VK.Widgets.Group('vk_groups', {
        mode: 3,
        width: 'auto'
      }, 153817553)
    }
  },
  methods: {
    initAjax () {
      var id = this.$route.params.id
      axios.get('https://lk.when-hungry.com/mobile/get-blog?uid=' + this.$root.auth.uid + '&id=' + id).then(response => {
        this.last = response.data.last
        this.next = response.data.next
        this.blog = response.data.current
        this.replies = response.data.replies
      })
    }
  },
  watch: {
    $route (to, from) {
      var id = to.params.id
      axios.get('https://lk.when-hungry.com/mobile/get-blog?uid=' + this.$root.auth.uid + '&id=' + id).then(response => {
        this.last = response.data.last
        this.next = response.data.next
        this.blog = response.data.current
        this.replies = response.data.replies
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/singleBlog.vue